"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.str2ab = exports.arrayBufferToB64 = void 0;
exports.arrayBufferToB64 = function (arrayBuffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
};
/**
 * Converts a string to an ArrayBuffer
 * @param str
 */
function str2ab(str) {
    return new TextEncoder().encode(str);
}
exports.str2ab = str2ab;
//# sourceMappingURL=utils.js.map